import {
  Typography,
  Grid,
  Button,
  TextField,
  CircularProgress,
  Box,
} from '@mui/material';
import React, {
  SetStateAction,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';

import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Slider from '@mui/material/Slider';

import { COLORS } from '../../../utils/colors';
import { ACCOUNT_SETTINGS_TEXT_FIELDS } from '../../../utils/data';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useUserProfile from '../../../hooks/useUserProfile';
import { PASSWORD_FIELDS } from '../../../utils/data/accountSetting';
//import { FilePond, registerPlugin } from 'react-filepond';
import { IUserSettings } from '../../../global/interfaces';
import { IOrganization } from '@homeporter/types';
import { applyApplicationFontSize } from '../../../utils/helpers';
import {
  FlexBetween,
  StyledModal,
  StyledOverlay,
  useAccountSettingsStyles,
} from './styles';
import SaveIcon from '../../../icons/SaveIcon';

interface FormValues {
  firstname: string;
  lastname: string;
  email: string;
  mobile: string;
  password: string;
  confirmPassword: string;
  dev: boolean;
  stats: boolean;
}
interface IProps {
  gitHash: string;
  organization: IOrganization;
  profile: any;
  userSettings: IUserSettings;
  isModalOpen: boolean;
  handleCloseModal: React.Dispatch<SetStateAction<boolean>>;
}

const AccountSettings = ({
  gitHash,
  organization,
  profile,
  userSettings,
  isModalOpen,
  handleCloseModal,
}: IProps) => {
  const styles = useAccountSettingsStyles();
  const [showSave, setShowSave] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [dragging, setDragging] = useState<boolean>(false);
  const [isUploading, setIsUploading] = useState(false);

  const initialValues = useMemo(
    () => ({
      firstname: profile?.name || '',
      lastname: profile?.family_name || '',
      email: profile?.email || '',
      mobile: profile?.phone_number || '',
      password: '',
      confirmPassword: '',
      dev: userSettings?.dev || false,
      stats: userSettings?.stats || false,
    }),
    [profile, userSettings],
  );

  const { updateProfile } = useUserProfile();
  let pond: any = null;
  const [image, setImage] = useState<any>();
  const [uploadError, setUploadError] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploadCanceled, setIsUploadCanceled] = useState(false);

  const { values, handleChange, errors, handleSubmit, resetForm } =
    useFormik<FormValues>({
      initialValues,
      enableReinitialize: true,
      validationSchema: Yup.object({
        firstname: Yup.string().required('First Name is required'),
        lastname: Yup.string(),
        email: Yup.string()
          .email('Invalid email address')
          .required('Email is required'),
        mobile: Yup.string()
          .matches(
            /^\+1\d{10}$/,
            'Phone must start with "+1" and have 11 digits',
          )
          .required('Phone is required'),
        password: Yup.string()
          .min(8, 'Password must be at least 8 characters')
          .matches(
            /^(?=.*[@#$%^&+!=]).*$/,
            'Password must include at least one special character',
          ),
        confirmPassword: Yup.string().oneOf(
          [Yup.ref('password'), undefined],
          'Passwords must match',
        ),
      }),
      onSubmit: async (payload) => {
        console.log('::::onSubmit payload:', payload);

        setLoading(true);
        try {
          await updateProfile(
            userSettings['fontSize'] !== fontSize
              ? { ...payload, fontSize, dev: values.dev, stats: values.stats }
              : payload,
          );
          setShowSave(false);
          handleChange('password')('');
          handleChange('confirmPassword')('');
        } catch (err) {
          console.log('::::updateProfile error:', err);
        } finally {
          setLoading(false);
        }
      },
      validateOnChange: false,
      validateOnBlur: false,
    });

  useEffect(() => {
    console.log('::::useEffect values:', values);
    setShowSave(JSON.stringify(initialValues) !== JSON.stringify(values));
  }, [values, initialValues]);

  const onCloseModal = () => {
    handleCloseModal(true);
    resetForm();
    setShowSave(false);
  };

  const [fontSize, setFontSize] = useState(
    userSettings['fontSize'] ? userSettings['fontSize'] : 100,
  );

  const applyFontSize = () => {
    applyApplicationFontSize(fontSize);
    setShowSave(true);
  };

  const handleSliderChange = (event: Event, value: number | number[]) => {
    setFontSize(value as number);
  };

  const handleSave = () => {
    console.log('::::handleSave:', values);
    handleSubmit();
    //setShowSave(false);
  };
  /*
  const [developer, setDeveloper] = useState(false);
  const handleSetDeveloper = () => {
    if (!userSettings) return;

    userSettings['dev'] = !developer;
    setDeveloper(!developer);
    setShowSave(true);
  };

  useEffect(() => {
    setDeveloper(!!userSettings?.['dev']);
  }, [userSettings?.['dev']]);
*/
  /*

  const handleAddImageStart = () => {
    setIsUploading(true);
    setUploadError(false);
    setUploadProgress(0);
    setIsUploadCanceled(false);
    // setReportUrl('');
  };

  const handleProcessFile = (_file: any, progress: any) => {
    setUploadProgress(Math.round(progress * 100));
  };

  const handleUploadFile = (data: any) => {
    const response = JSON.parse(data);
    if (response?.status === 'success') {
      // setReportUrl(response.data.report_url);
      setUploadProgress(0);
      setIsUploading(false);
    }
    return data;
  };
  
  const handleBrowseClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Handle drag over event
  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // Necessary for drop to work
    setDragging(true);
  };

  // Handle drag leave event
  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragging(false);
    // Handle file drop
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      uploadFile(files);
    }
  };

  const uploadFile = (file: any) => {};

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      uploadFile(files);
    }
  };

  const [developer, setDeveloper] = useState(false);
  const handleSetDeveloper = () => {
    setDeveloper(!developer);
    profile.settings['developer'] = true;
  };
  */

  return (
    <StyledOverlay open={isModalOpen} onClose={onCloseModal}>
      <StyledModal>
        <FlexBetween sx={{ mb: '2rem' }}>
          <Typography fontWeight={600} fontSize="1.125rem">
            Account Details
          </Typography>

          {showSave && (
            <Button
              sx={styles.saveButton}
              onClick={() => handleSave()}
              startIcon={
                loading ? <CircularProgress size={20} /> : <SaveIcon />
              }>
              {loading ? 'Saving...' : 'Save'}
            </Button>
          )}
        </FlexBetween>

        <Grid container columnSpacing={2} rowSpacing={1} marginTop={'.5rem'}>
          {ACCOUNT_SETTINGS_TEXT_FIELDS.map(
            ({ label, value, type, error, disabled }) => {
              return (
                <Grid item xs={6} key={value} sx={{ marginBottom: '1rem' }}>
                  <TextField
                    fullWidth
                    label={label}
                    variant="outlined"
                    value={values[value as keyof typeof values]}
                    onChange={handleChange(value)}
                    error={!!errors[error as keyof typeof errors]}
                    inputProps={{
                      maxLength: 100,
                    }}
                    disabled={disabled}
                    helperText={
                      errors ? (
                        <span style={{ color: COLORS.RED }}>
                          {errors[value as keyof typeof errors]}
                        </span>
                      ) : (
                        ''
                      )
                    }
                  />
                </Grid>
              );
            },
          )}

          <Grid item xs={6} key="organization" sx={{ marginBottom: '1rem' }}>
            <TextField
              fullWidth
              label="Role"
              variant="outlined"
              value={userSettings?.supervisor ? 'Supervisor' : 'Inspector'}
              onChange={handleChange('organization')}
              inputProps={{
                maxLength: 100,
              }}
              disabled={true}
            />
          </Grid>
        </Grid>
        <span style={styles.divider}></span>
        <Typography fontWeight={600} fontSize="1.125rem">
          Organization
        </Typography>
        <Grid container columnSpacing={2} rowSpacing={1} marginTop={'.5rem'}>
          <Grid item xs={6} key="organization" sx={{ marginBottom: '1rem' }}>
            <TextField
              fullWidth
              label="Organization"
              variant="outlined"
              value={organization.name}
              onChange={handleChange('organization')}
              inputProps={{
                maxLength: 100,
              }}
              disabled={true}
            />
          </Grid>
        </Grid>
        <span style={styles.divider}></span>
        <Typography fontWeight={600} fontSize="1.125rem">
          Update Password
        </Typography>
        <Grid container columnSpacing={2} rowSpacing={1} marginTop={'.5rem'}>
          {PASSWORD_FIELDS.map(({ label, value, type, error, disabled }) => {
            return (
              <Grid item xs={6} key={value}>
                <TextField
                  fullWidth
                  type={type === 'password' ? 'password' : 'text'}
                  label={label}
                  variant="outlined"
                  value={values[value as keyof typeof values]}
                  onChange={handleChange(value)}
                  error={!!errors[error as keyof typeof values]}
                  inputProps={{
                    maxLength: 30,
                  }}
                  disabled={disabled}
                  helperText={
                    errors ? (
                      <span style={{ color: COLORS.RED }}>
                        {errors[value as keyof typeof errors]}
                      </span>
                    ) : (
                      ''
                    )
                  }
                />
              </Grid>
            );
          })}
        </Grid>
        <span style={styles.divider}></span>
        <Typography fontWeight={600} fontSize="1.125rem">
          Screen Resolution
        </Typography>
        <Box sx={{ padding: '2rem 0' }}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <Typography>Font Size:</Typography>
            </Grid>
            <Grid item xs>
              <Slider
                aria-label="Volume"
                sx={{ width: '33%' }}
                min={50}
                max={150}
                value={fontSize}
                onChange={handleSliderChange}
                onMouseUp={applyFontSize}
              />
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => {
                  setFontSize(100);
                  applyApplicationFontSize(100);
                  setShowSave(true);
                }}>
                Reset
              </Button>
            </Grid>
          </Grid>
        </Box>

        {userSettings?.dev ||
          (userSettings?.supervisor && (
            <>
              <span style={styles.divider}></span>
              <Typography fontWeight={600} fontSize="1.125rem">
                Application Settings
              </Typography>
            </>
          ))}

        <Box sx={{ padding: '1rem 0' }}>
          {userSettings?.dev && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Typography>Developer Mode:</Typography>
              <Typography>{userSettings?.dev ? 'On' : 'Off'}</Typography>
            </Box>
          )}
          {userSettings?.supervisor && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Typography>Supervisor Mode:</Typography>
              <Typography>{userSettings?.supervisor ? 'On' : 'Off'}</Typography>
            </Box>
          )}
          {false && userSettings?.dev && (
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={values.stats}
                    onChange={(e) => {
                      handleChange('stats')(e);
                      setShowSave(true);
                    }}
                  />
                }
                label="Show Video Stats"
              />
            </FormGroup>
          )}
          <Typography
            fontSize="0.75rem"
            color={COLORS.DARK_GREY}
            position="absolute"
            bottom={'1rem'}
            left={'1rem'}>
            Build: {gitHash}
          </Typography>
        </Box>
      </StyledModal>
    </StyledOverlay>
  );
};

export default AccountSettings;
